import { render, staticRenderFns } from "./International1.vue?vue&type=template&id=424852bc&scoped=true&"
import script from "./International1.vue?vue&type=script&lang=js&"
export * from "./International1.vue?vue&type=script&lang=js&"
import style0 from "./International1.vue?vue&type=style&index=0&id=424852bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424852bc",
  null
  
)

export default component.exports